import React from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import cineslide1 from '../../../assets/front/img/cinema/cineslide-1.png';
import cineslide2 from '../../../assets/front/img/cinema/cineslide-2.png';
import cine1 from '../../../assets/front/img/cinema/cine-1.jpg';

class Guide extends React.Component {

    componentDidMount() {
        document.querySelector("main").scrollIntoView();
    }

    render() {
        var settings = {
            autoplay: true,
            dots: true,
            infinite: true,
            autoplaySpeed: 5000,
            slidesToShow: 1,
            slidesToScroll: 1
        };
        return (
            <div className="container">
                <div className="g-my-30">
                    <Slider {...settings}>
                        <div>
                            <img src={cineslide1} className="img-fluid mx-auto d-block" alt="" />
                        </div>
                        <div>
                            <img src={cineslide2} className="img-fluid mx-auto d-block" alt="" />
                        </div>
                    </Slider>
                </div>

                <div className="row justify-content-center">
                    <div className="col-lg-10 g-pb-50">
                        <h2 className="h3 g-color-primary g-font-weight-600 g-py-20">카라 동물영화제  |  KARA Animal Film Festival</h2>
                        <div className="row g-py-10">
                            <div className="col-md-2">
                                <h3 className="h4 g-font-weight-600">슬로건</h3>
                            </div>
                            <div className="col-md-10">
                                <p>살아있는 모든 것, 다 행복하라</p>
                            </div>
                        </div>
                        <div className="row g-py-10">
                            <div className="col-md-2">
                                <h3 className="h4 g-font-weight-600">성격</h3>
                            </div>
                            <div className="col-md-10">
                                <p>
                                    · 동물권 다룬 신작 소개로 동물권에 대한 사회적 관심 확산<br />
                                    · 동물권을 둘러싼 현실과 이슈를 이해하고 실천방안을 모색하는 GV<br />
                                    · 동물의 고통이 없는 ‘일회용 플라스틱 없는 영화제’</p>
                            </div>
                        </div>
                        <div className="row g-py-10">
                            <div className="col-md-2">
                                <h3 className="h4 g-font-weight-600">소개 </h3>
                            </div>
                            <div className="col-md-10">
                                <p>
                                    동물이 존엄한 생명으로서 본연의 삶을 영위하고, 모든 생명이 균형과 조화 속에 공존하는 세상으로 향할 수 있도록 동물권행동 카라는 매해 동물영화제를 진행합니다.<br />
                                    카라 동물영화제는 동물이 살아가고 있는 현실 그대로를 보여주며 평화로운 공존을 위해 인간과 동물의 관계가 어떻게 변화해야하는지 관객에게 질문을 던지는 영화들을 소개하는 영화제입니다.
                                </p>
                            </div>
                        </div>

                        <hr />

                        <div className="row">
                            <div className="col-lg-4 g-py-20">
                                <img src={cine1} className="img-fluid" alt="" />
                            </div>
                            <div className="col-lg-8 g-py-20">
                                <h3 className="h4 g-color-primary g-font-weight-600 g-mb-3">제1회 카라 동물영화제</h3>
                                <ul className="g-pl-20">
                                    <li className="mb-3"><b>개최시기 </b> &nbsp; 2018.10.12.-10.13</li>
                                    <li className="mb-3"><b>장소</b> &nbsp; 롯데시네마 홍대입구 1관</li>
                                    <li className="mb-3"><b>규모</b> &nbsp; 6편 영화상영, 4회 GV(게스트와의 만남), 1회 특별게스트 초청 간담회</li>
                                    <li className="mb-3"><b>슬로건 </b> &nbsp; 살아있는 모든 것, 다 행복하라</li>
                                    <li className="mb-3"><b>주최 </b> &nbsp; (사)동물권행동 카라</li>
                                    <li className="mb-3"><b>상영작</b><br />
                                        <ul className="g-pl-20">
                                            <li>언더독 Underdog | 오성윤, 이춘백 | 한국 | 2018 | 102분 | 애니메이션</li>
                                            <li>블루 Blue | 카리나 홀든 | 오스트레일리아 | 2017 | 76분 | 다큐멘터리</li>
                                            <li>코끼리와 바나나 Love & Bananas: An Elephant Story | 애슐리 벨 | 미국 | 2018 | 77분 | 다큐멘터리</li>
                                            <li>소닉 씨 Sonic Sea | 미셀 도허티. 다니엘 하이너펠드 | 미국 | 2016 | 60분 | 다큐멘터리</li>
                                            <li>매직 알프스 Magic Alps | 안드레아 브루사, 마르코 스코투찌 | 이탈리아 | 2018 | 15분 | 드라마</li>
                                            <li>마지막 돼지 The Last Pig | 앨리슨 아르고 | 미국 | 2017 | 54분 | 다큐멘터리</li>
                                        </ul>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Guide;


// WEBPACK FOOTER //
// ./src/pages/front/cinema/guide.js